import { useMemo } from 'react';
import { hashKey, useInfiniteQuery } from '@tanstack/react-query';
import { TWO_MINUTES_MS } from '@izimi/utils';
import { sharedQueryKeys } from './cache';
import { mapSharedItemsToEntities } from './helpers';
const createSharedModule = ({ sharedApi, }) => {
    const usePagedSharedItems = ({ pageSize = 15, enabled, ...params } = {}) => {
        const { data, isLoading, error, refetch, hasNextPage, fetchNextPage, isFetchingNextPage } = useInfiniteQuery({
            queryKey: sharedQueryKeys.getSharedItems(params),
            initialPageParam: 0,
            queryFn: async ({ pageParam, queryKey }) => sharedApi.getSharedItems({ params: { offset: Number(pageParam), limit: pageSize, ...params }, queryKeyHash: hashKey(queryKey) }),
            getNextPageParam: (lastPage, allPages) => {
                const totalFetchedItems = allPages.flatMap(page => page.items).length;
                return totalFetchedItems < lastPage.total ?
                    allPages.length * pageSize :
                    undefined;
            },
            enabled,
            staleTime: TWO_MINUTES_MS,
        });
        const sharedItems = useMemo(() => data?.pages.flatMap(mapSharedItemsToEntities), [data]);
        const metadata = useMemo(() => data?.pages[0]?.metadata, [data]);
        return {
            metadata,
            sharedItems,
            isLoading,
            error,
            total: data?.pages[0]?.total ?? 0,
            refetch,
            hasNextPage,
            fetchNextPage,
            isFetchingNextPage,
        };
    };
    return {
        usePagedSharedItems,
    };
};
export default createSharedModule;
